"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToastDispatch = exports.useToastState = exports.ToastProvider = exports.ToastDispatchContext = exports.ToastStateContext = void 0;

var _tslib = require("tslib");

var _react = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var ToastStateContext = (0, _react.createContext)(undefined);
exports.ToastStateContext = ToastStateContext;
var ToastDispatchContext = (0, _react.createContext)(undefined);
exports.ToastDispatchContext = ToastDispatchContext;

var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'ADD_TOAST':
      return {
        toasts: (0, _tslib.__spreadArrays)(state.toasts, [action.toast])
      };

    case 'DELETE_TOAST':
      var toasterIndex = state.toasts.findIndex(function (toast) {
        return toast.id === action.id;
      });
      state.toasts.splice(toasterIndex, 1);
      return {
        toasts: (0, _tslib.__spreadArrays)(state.toasts)
      };

    default:
      return state;
  }
};

var ToastProvider = function ToastProvider(_a) {
  var children = _a.children;

  var _b = (0, _react.useReducer)(reducer, {
    toasts: []
  }),
      state = _b[0],
      dispatch = _b[1];

  return _react.default.createElement(ToastStateContext.Provider, {
    value: state
  }, _react.default.createElement(ToastDispatchContext.Provider, {
    value: dispatch
  }, children));
};

exports.ToastProvider = ToastProvider;

var useToastState = function useToastState() {
  var context = (0, _react.useContext)(ToastStateContext);

  if (context === undefined) {
    throw new Error('useToast must be used within ToastProvider');
  }

  return context;
};

exports.useToastState = useToastState;

var useToastDispatch = function useToastDispatch() {
  var context = (0, _react.useContext)(ToastDispatchContext);

  if (context === undefined) {
    throw new Error('useToastDispatch must be used within ToastProvider');
  }

  return context;
};

exports.useToastDispatch = useToastDispatch;